import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { type SelectProps } from '@mui/material/Select';

import { type AllRepeatDetails, Months } from '../../Repeat.types';
import { getLabelSize, monthShortTextMapping } from '../../utils';

interface SelectMonthProps {
  value: AllRepeatDetails;
  onChange: (value: AllRepeatDetails) => void;
  disabled: boolean;
  inputSize: 'small' | 'medium';
  inputVariant: SelectProps['variant'];
}
const sxMinWidth = { minWidth: 120 };

const SelectMonth = ({ value, onChange, disabled, inputSize, inputVariant }: SelectMonthProps) => {
  const displayValue = disabled ? null : (value.byMonth?.[0] ?? null);
  const labelSize = getLabelSize(inputSize);

  return (
    <FormControl fullWidth>
      <InputLabel
        id="select-month-label"
        {...{ disabled }}
        shrink={!disabled && Boolean(displayValue)}
        size={labelSize}
      >
        Select Month
      </InputLabel>
      <Select
        sx={sxMinWidth}
        onChange={(e) =>
          onChange({
            ...value,
            byMonth: [Number.parseInt(e.target.value, 10)],
          })
        }
        value={displayValue == null ? '' : String(displayValue)}
        labelId="select-month-label"
        label={!disabled && Boolean(displayValue) ? 'Select Month' : undefined}
        {...{ size: inputSize, disabled: disabled }}
        variant={inputVariant}
      >
        <MenuItem value="" key={0} disabled>
          None
        </MenuItem>
        {Object.values(Months).map((key) => (
          <MenuItem key={key} value={key}>
            {monthShortTextMapping[key]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectMonth;
